import { ApiClient } from '@/services/ApiClient.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { ChatLoader } from '@sigma/client/chat/ChatLoader.js';
import { ChatLoadEndpoint } from '@sigma/patient-api/chat/ChatLoadEndpoint.js';

/**
 * Patient-app implementation of ChatLoader.
 * Delegates to the patient ChatLoadEndpoint.
 */
export const PatientChatLoader = defineService({
    name: 'PatientChatLoader',
    implements: ChatLoader,
    deps: {
        api: ApiClient,
    },
    setup({ api }): ChatLoader {
        return async (chatId, fromSeq) => {
            return await api(ChatLoadEndpoint, {
                chatId,
                fromIndex: fromSeq,
            });
        };
    },
});
